import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react';
import {
  MAX_IMAGE_UPLOAD_COUNT,
  MAX_IMAGE_UPLOAD_SIZE_MB,
} from '@/comp/Forms/SiteSurveyForm/RoomConfigurationStep/FormComponents/ImageUpload/ImageUpload.consts';
import { ImageTags } from '@/comp/Forms/SiteSurveyForm/RoomConfigurationStep/FormComponents/ImageUpload/components/MobileUploadWizzard/components/common/';
import { useStores } from '@/hooks/use-stores';
import { ImageUploadButtons } from '@/comp/Forms/SiteSurveyForm/RoomConfigurationStep/FormComponents/ImageUpload/components/common';
import { useImageCompression } from '@/comp/Forms/SiteSurveyForm/RoomConfigurationStep/FormComponents/ImageUpload/hooks/useImageCompression';
import { StyledStep } from './ImageSelectMobile.styles';

export const ImageSelectMobile: FC = observer(() => {
  const { t } = useTranslation();
  const { imageUploadStore } = useStores();
  const params = useImageCompression({ onComplete: imageUploadStore.goToNextStep });

  return (
    <StyledStep>
      <div className="mobile-image-select-body">
        <h3 className="mobile-image-select-title">{t('uploadImageTitle')}</h3>
        <p className="mobile-image-select-helper-text">{t('uploadImageMobileSelectHelperText')}</p>
        <ImageTags className="mobile-image-select-tag-list" />
        <p className="mobile-image-select-file-limit">
          {t('uploadImageRules', { limit: MAX_IMAGE_UPLOAD_COUNT, maxSize: MAX_IMAGE_UPLOAD_SIZE_MB })}
        </p>
      </div>
      <div className="mobile-image-upload-footer">
        <ImageUploadButtons buttonText="uploadImageUnifiedButtonText" {...params} />
      </div>
    </StyledStep>
  );
});
